import {Component, CUSTOM_ELEMENTS_SCHEMA, viewChild} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MonacoEditorComponent} from '../components/monaco-editor/monaco-editor.component';

@Component({
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        FormsModule,
        MonacoEditorComponent
    ],
    template: `
        <div class="fullsize-vbox" style="align-items: flex-start; gap: 10px">
            <app-monaco-editor #editor></app-monaco-editor>

            <div class="toolbar-horizontal">
                <fluent-button (click)="setValue('hi')">Value</fluent-button>
                <fluent-button (click)="setFontSize(20)">Font</fluent-button>
                <fluent-button (click)="setLanguage('json')">JSON</fluent-button>
            </div>
        </div>
    `,
    styles: `
    `
})
export class TestMonacoComponent {

    private readonly editor = viewChild.required<MonacoEditorComponent>('editor');

    constructor() {
    }

    setValue(value: string) {
        this.editor().setValue('hi');
    }

    setFontSize(number: number) {
        this.editor().setFontSize(number);
    }

    setLanguage(language: string) {
        this.editor().setLanguage(language);
    }
}
